import React, {Component} from 'react';
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import NavBarKS from "../../components/NavBarKS";
import Select from"../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';
import Alert from "react-s-alert";
import {isValidHiddenVknTcknList} from "../../common/componentValidation";
import _ from "lodash";

class HiddenVknTcknList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hiddenVknTcknList:[],
			initHiddenVknTcknList:[],
			users:[],
            saveLoading:false
		};
        this.onChange             = this.onChange.bind(this);
        this.removeHiddenVknTckn  = this.removeHiddenVknTckn.bind(this);
        this.addHiddenVknTcknLine = this.addHiddenVknTcknLine.bind(this);
        this.saveHiddenVknTcknList= this.saveHiddenVknTcknList.bind(this);
	}

    componentWillMount() {
		let self = this;
		let params = {
			url: '/hiddenvkntckn/getHiddenVknTcknList',
			method: "post",
		};
		request(params)
		.then(function (response) {
		    let hiddenVknTcknList = response.data;
		    if(hiddenVknTcknList.length===0){
                hiddenVknTcknList.push({
                    recordId: null,
                    userId  : null,
                    vknTckn : null,
                    invoiceType: 1,
                    customerId: null,
                });
            }
			self.setState({hiddenVknTcknList,initHiddenVknTcknList:deepCopyObject(hiddenVknTcknList)});
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

    componentDidMount() {
		let self = this;
		let params = {
			url: '/hiddenvkntckn/getList',
			method: "post",
		};
		request(params)
		.then(function (response) {
			self.setState({users: response.data.users});
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

    removeHiddenVknTckn(index) {
        let hiddenVknTcknList = deepCopyObject(this.state.hiddenVknTcknList);
        hiddenVknTcknList.splice(index, 1);
        this.setState({hiddenVknTcknList});
    }

    onChange(e,index) {
        let hiddenVknTcknList = deepCopyObject(this.state.hiddenVknTcknList);
        let hiddenVknTckn = this.state.hiddenVknTcknList[index];
        hiddenVknTckn[e.name]=e.value;
        hiddenVknTcknList[index] = hiddenVknTckn;
        this.setState({hiddenVknTcknList})
    }

    saveHiddenVknTcknList() {
	    let self= this;
        if ((_.isEqual(self.state.hiddenVknTcknList, self.state.initHiddenVknTcknList))) {
            Alert.info("Listede değişiklik yapmamışsınız. Kayıt gerekmemektedir.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 1000
            });
            return;
        }

        let result = isValidHiddenVknTcknList(self.state.hiddenVknTcknList);
        let valid = result.valid;
        if (valid) {
            let self = this;
            let params = {
                url: '/hiddenvkntckn/saveHiddenVknTcknList',
                method: "post",
                data: this.state.hiddenVknTcknList
            };
            self.setState({saveLoading:true});
            request(params)
            .then(function (response) {
                let hiddenVknTcknList = response.data;
                if(hiddenVknTcknList.length===0){
                    hiddenVknTcknList.push({
                        recordId: null,
                        userId  : null,
                        vknTckn : null,
                        invoiceType: 1,
                        customerId: null
                    });
                }
                self.setState({hiddenVknTcknList,initHiddenVknTcknList:deepCopyObject(hiddenVknTcknList),saveLoading:false});
                Alert.closeAll();
                Alert.success("İşlem Başarılı", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
                showAxiosError(error);
                self.setState({saveLoading:false});
            });
	    }else{
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            self.setState({saveLoading: false});
        }
    }

    addHiddenVknTcknLine() {
        let hiddenVknTcknList = deepCopyObject(this.state.hiddenVknTcknList);
        hiddenVknTcknList.push({
            recordId: null,
            userId  : null,
            vknTckn : null,
            invoiceType: null,
            customerId: null,
        });
        this.setState({hiddenVknTcknList});
    }

    render() {

		return (
			<div className="row baseBackground">
				<NavBarKS/>
				<div className="col-sm-12 satirBasi">
					<div className="card-header d-flex justify-content-between">
						<h4 className="card-title">Kullanıcı VKN/TCKN Kısıtları</h4>
                        <button type="button" className="Btn ekle pull-right"
                                style={{margin: "0", background: '#3fb0ac'}}
                                onClick={() => this.addHiddenVknTcknLine()}>
                        </button>
					</div>
					<div className="card-body">
						<div className="row">

							<div className="col-sm-12" id="hiddenVknTcknTable">
                                <table className="" style={{textAlign: 'center'}}>
                                    <thead>
                                        <tr style={{backgroundColor: '#ebedf0'}}>
                                            <th width="4%">#</th>
                                            <th width="24%">Kullanıcı Adı</th>
                                            <th width="24%">VKN/TCKN</th>
                                            <th width="24%">Liste Türü</th>
                                            <th width="24%">İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.hiddenVknTcknList.map((hiddenVknTckn, index) =>
                                            <tr key={index +"_" +this.state.hiddenVknTcknList.length}>
                                                <td data-label={"#"}>{index+1}</td>
                                                <td data-label={"Kullanıcı Adı"}>
                                                    <Select
                                                        placeholder="Kullanıcı Seçiniz"
                                                        value={hiddenVknTckn.userId}
                                                        clearable={false}
                                                        style={{width: "100%"}}
                                                        noResultsText="Sonuç yok"
                                                        onChange={(e) => e && this.onChange({
                                                            value: e.value,
                                                            name: "userId"
                                                        }, index)}
                                                        options={this.state.users.map(user => ({
                                                            value: user.recordId,
                                                            label: user.username
                                                        }))}
                                                    />
                                                </td>
                                                <td data-label={"VKN/TCKN"}>{
                                                    <input className="form-control"
                                                           autoComplete="false"
                                                           maxLength="11"
                                                           type="text"
                                                           name="vknTckn"
                                                           value={hiddenVknTckn.vknTckn}
                                                           onChange={(e) => e && this.onChange({name:e.target.name,value:e.target.value},index)}/>
                                                }</td>
                                                <td data-label={"Liste Türü"}>
                                                    <Select
                                                        placeholder="Liste Türü Seçiniz"
                                                        value={hiddenVknTckn.invoiceType}
                                                        clearable={false}
                                                        style={{width: "100%"}}
                                                        noResultsText="Sonuç yok"
                                                        onChange={(e) => e && this.onChange({
                                                            value: e.value,
                                                            name: "invoiceType"
                                                        }, index)}
                                                        options={[
                                                            {label:'Gelen e-Fatura', value:1},
                                                            {label:'Giden e-Fatura', value:2},
                                                            {label:'E-Arşiv Fatura', value:3}
                                                        ]}
                                                    />
                                                </td>
                                                <td data-label={"İşlemler"}>{
                                                    <div>
                                                        <button type="button" className="Btn temizle"
                                                                style={{margin: "0", background: '#FFCCCC'}}
                                                                onClick={() => this.removeHiddenVknTckn(index)}>

                                                        </button>
                                                    </div>
                                                }</td>
                                            </tr>
                                    )}
                                    </tbody>
                                </table>
							</div>
						</div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="" style={{float: 'right'}}>
                                    <button type="button"
                                            style={{padding: '9px 39px 9px 13px', float: 'right', background:'#c2d4d8', marginRight:'2px'}}
                                            disabled={this.state.saveLoading}
                                            className="col-sm-21 TekBtn kaydet"
                                            onClick={this.saveHiddenVknTcknList}>Kaydet
                                    </button>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</div>
		);
	}
}

export default HiddenVknTcknList;